import { FRONTEND_PROPERTY_NAME, SYSTEM_RESERVED_GLOBALS, } from '../../common/constants.js';
import { isValidGlobalVariableName } from '../../common/utilities.js';
export function validateGlobalVariables(node, nodeFields, accept) {
    const { idField, nodeTypeField, variablesField } = nodeFields;
    if (!variablesField)
        return;
    const variables = variablesField?.variables?.map((v) => v.value) || [];
    if (nodeTypeField?.nodeType?.value === 'D' && variables.length > 1) {
        accept('error', `A decision node cannot have more than one global variable.`, {
            node: variablesField,
            data: {
                id: idField?.id?.value,
                nodeNumber: node?.name,
                propertyName: FRONTEND_PROPERTY_NAME.VARIABLES,
            },
        });
    }
    const variableFlags = {};
    variables?.forEach((variable) => {
        if (!isValidGlobalVariableName(variable)) {
            accept('error', `The global variable '${variable}' name must start with a capital letter and contain capital letters, numbers and _ only.`, {
                node: variablesField,
                data: {
                    id: idField?.id?.value,
                    nodeNumber: node?.name,
                    propertyName: FRONTEND_PROPERTY_NAME.VARIABLES,
                },
            });
        }
        // Ensure that the variable name is not in the system reserved
        // global variable names
        if (SYSTEM_RESERVED_GLOBALS.indexOf(variable) !== -1) {
            accept('error', `System reserved global variable name '${variable}' cannot be used.`, {
                node: variablesField,
                data: {
                    id: idField?.id?.value,
                    nodeNumber: node?.name,
                    propertyName: FRONTEND_PROPERTY_NAME.VARIABLES,
                },
            });
        }
        if (variableFlags[variable]) {
            accept('error', `Duplicate variable '${variable}' found.`, {
                node: variablesField,
                data: {
                    id: idField?.id?.value,
                    nodeNumber: node?.name,
                    propertyName: FRONTEND_PROPERTY_NAME.VARIABLES,
                },
            });
        }
        variableFlags[variable] = true;
    });
}
//# sourceMappingURL=validate-global-variables.js.map